import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';

import { BasicService } from '../../services/basic.service';
import { SearchBarService } from './search-bar.service';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SearchBarComponent implements OnDestroy {
  @Input() primaryButtonAction: any;
  @Input() primaryButtonDisabled = false;
  @Input() primaryButtonKey: string;

  @Input() secondaryButtonAction: any;
  @Input() secondaryButtonKey: string;

  @Input() searchKey: string;

  resultsLabel: string;
  searchCtrl = new FormControl('', Validators.minLength(3));

  private subscriptions: Subscription = new Subscription();

  constructor(private basicService: BasicService, public searchBarService: SearchBarService) {
    this.subscriptions.add(
      this.searchCtrl.valueChanges
        .pipe(
          debounceTime(300),
          filter(value => value !== null && (!value || value.length >= 3))
        )
        .subscribe(value => {
          searchBarService.filtersMap.set('search', value);
          this.searchBarService.searchAndSortBS.next(true);
        })
    );
    this.subscriptions.add(
      this.searchBarService.clearFiltersBS.subscribe(value => {
        if (value) {
          this.searchCtrl.reset();
        }
      })
    );
    this.subscriptions.add(searchBarService.totalBS.subscribe(this.updateResultsLabel));
  }

  clearSearch() {
    this.searchCtrl.reset();
    this.searchBarService.filtersMap.delete('search');
    this.searchBarService.searchAndSortBS.next(true);
  }

  clearFilters() {
    const element = document.getElementById('clear-filters');
    element.classList.add('dismiss');
    this.searchBarService.clearFiltersBS.next(true);
    this.searchBarService.searchAndSortBS.next(true);
  }

  private updateResultsLabel = (total: number) => {
    let label = this.basicService.translate('engagement/history/single-sent-messages', { total: `${total}` });
    if (total > 1) {
      label = this.basicService.translate('engagement/history/nb-sent-messages', { total: `${total}` });
    }
    this.resultsLabel = label;
  };

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
    this.searchBarService.clearFiltersBS.next(true);
  }
}
